import { useEffect, useState } from "react";
import Spinner from "./Spinner/spinner";
import callApi from "../../../utility/apiCaller";
import { useSelector } from "react-redux";

export const FinalRedirectScreen = ({
  message = "Give us a few \n seconds to process \n your application",
  setCurrentStep,
}) => {
  const [loading, setLoading] = useState(true);
  const aaSlice = useSelector((state) => state?.aa);
  const opportunityId = aaSlice?.OpportunityId;
  const user = useSelector((state) => state.app.user);
  const lead_Id = aaSlice?.internalLeadId;

  // Retry util with exponential backoff
  const withRetry = async (fn, retries = 3, delay = 1000) => {
    let attempt = 0;
    while (attempt < retries) {
      try {
        return await fn();
      } catch (err) {
        attempt++;
        if (attempt >= retries) throw err;
        console.warn(`Retrying... attempt ${attempt}`);
        await new Promise((res) => setTimeout(res, delay * attempt));
      }
    }
  };

  const callApiWithRetryAndTest = async (
    apiFunc,
    testFunc,
    errorMsg,
    retries = 3,
    delay = 5000
  ) => {
    return await withRetry(
      async () => {
        const res = await apiFunc();
        if (testFunc && !testFunc(res)) {
          throw new Error(errorMsg || "Validation failed");
        }
        return res;
      },
      retries,
      delay
    );
  };

  // Poll Disbursal Callback
  useEffect(() => {
    let intervalId;
    let attemptCount = 0;
    const maxAttempts = 5;

    const pollDisbursalCallback = async () => {
      attemptCount++;
      if (attemptCount > maxAttempts) {
        console.warn("❌ Max disbursal attempts reached, stopping polling");
        clearInterval(intervalId);
        return;
      }

      try {
        const res = await callApiWithRetryAndTest(
          () =>
            callApi(
              "v1/callback/list",
              "post",
              {
                filters: {
                  event: "Disbursal_Callback",
                  opportunityid: opportunityId,
                },
              },
              "loan-service"
            ),
          (res) => {
            const list = res?.data?.callbackList || [];
            // if (!list.length) return false; //testing 25092025

            // Check if latest callback shows Disbursed
            // const latest = list[0]; //testing 25092025
            // return latest?.Status === "Disbursed";//testing 25092025
            return true;
          },
          "❌ Disbursal callback failed",
          3,
          1500
        );

        if (res) {
          console.log("✅ Disbursal confirmed:", res?.data?.callbackList[0]);

          await callApiWithRetryAndTest(
            () =>
              callApi(
                `v1/lead/${lead_Id}/update-lead-new`,
                "post",
                {
                  lead: {
                    is_loan_approval_completed: true,
                    steps_completed: 15,
                  },
                },
                "core",
                user?.token ||
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
              ),
            (res) => res?.status === "Success", // test function for lead
            "❌ Update lead failed",
            3,
            1000
          );

          setCurrentStep((prev) => prev + 1);
          clearInterval(intervalId);
        }
      } catch (err) {
        console.error(err);
      }
    };

    intervalId = setInterval(pollDisbursalCallback, 2000); // Poll every 2s

    return () => clearInterval(intervalId);
  }, [opportunityId, setCurrentStep, lead_Id, user?.token]);

  return (
    <div className="flex flex-col font-atkinson items-center h-[100dvh] justify-center bg-white text-center px-4">
      <Spinner />

      <h2 className="mt-4 text-lg font-bold text-gray-900">Hang tight!</h2>
      <p className="mt-1 text-[15px] text-gray-600">
        {message.split("\n").map((msg, index) => (
          <span key={index}>
            {msg}
            <br />
          </span>
        ))}
      </p>

      <div className="absolute bottom-6 flex flex-col items-center">
        <div className="text-center text-xs text-gray-500">
          <img
            src="/assets/img/Footer logo.png"
            alt="Digitmoney logo"
            className="mx-auto h-4 mb-1"
          />
          Lending Partner{" "}
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="inline h-4 ml-1"
          />
        </div>
      </div>
    </div>
  );
};
